module.exports = __webpack_public_path__ + "static/media/pinIcon.2910ffed.png";